module.exports = __webpack_public_path__ + "static/project-autoenroll-ce6ef50e5a959e650c38e26d2205cc85.png";